import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ROUTE_ACCESS_DENIED, ROUTE_FORBIDDEN, ROUTE_HOME, ROUTE_SIGN_IN } from '../_common/constants';
import { AuthService } from './auth.service';
import { PermissionEnum } from '../administration/users/user-permission.enum';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService
  ) { };

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const requiredPermission = route.data.requiredPermission as PermissionEnum;
      if (requiredPermission == undefined || this.authService.hasPermission(requiredPermission)){
        return true;
      } else {
        this.router.navigate([ROUTE_ACCESS_DENIED]);
        return false;
      }
    // const user = this.authService.authenticatedUser;
    
    // if (user) {
    //   if(route.data == null || Object.keys(route.data).length === 0)
    //     return true;

    //   if(user.roles.includes(route.data.role)){
    //     return true;
    //   }
    //   else {
    //     this.router.navigate([ROUTE_FORBIDDEN]);
    //   };
    // } else {
    //     // not logged in so redirect to login page with the return url
    //     this.router.navigate([ROUTE_SIGN_IN], { queryParams: { returnUrl: state.url } });
    //     return false;
    // }
  }
}
